import { Box, Button, Menu, MenuItem } from '@mui/material';
import { FC, SyntheticEvent, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateResponsibleUserRequest } from 'redux/reducers/errorCorrections/reducer';
import { UserAvatarMenu } from 'ui/UserAvatarMenu';
import { getUsersList } from 'redux/reducers/user/selectors';
import { TResponsibleUser } from 'redux/reducers/errorCorrections/types';
import { TUser } from 'redux/reducers/user/types';
import { errorsTableStructure } from '../../errors-table-structure';
import { TTableStructure } from '../../types';

export type TUserMenuProps = {
	errorId: number;
	responsibleUser: TUser;
};
export const UserMenu: FC<TUserMenuProps> = ({ errorId, responsibleUser }) => {
	const dispatch = useDispatch();
	const tableStructure = errorsTableStructure() as TTableStructure[];
	const usersList = useSelector(getUsersList);
	const usersList1 = [...(usersList ?? []), { id: '-', fullName: '', email: '-' }];

	const anchorEl = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);
	const speedDialTooltipOpen = (e: SyntheticEvent) => {
		if (!anchorEl) return;
		setOpen(true);
		e.stopPropagation();
	};
	const speedDialTooltipClose = (e: SyntheticEvent) => {
		setOpen(false);
		e.stopPropagation();
	};

	const handleSetUser = (user: string, e: SyntheticEvent) => {
		e.stopPropagation();
		dispatch(updateResponsibleUserRequest({ errorId: +(errorId ?? 0), responsibleUserId: user }));
		setOpen(false);
		// if (user === 'Fixed' && !item?.responsibleUser?.id && user?.id)
		// 	dispatch(
		// 		updateResponsibleUserRequest({
		// 			errorId: +(errorId ?? 0),
		// 			responsibleUserId: user?.id,
		// 		}),
		// 	);
	};
	const handleUserSelect = (index: number) => {
		console.log('UserMenu handleUserSelect', index);
		if (!usersList) return;
		dispatch(
			updateResponsibleUserRequest({
				errorId: +(errorId ?? 0),
				responsibleUserId: usersList[index].id,
			}),
		);
		// e.stopPropagation();
	};

	return (
		<>
			<Box
				onClick={speedDialTooltipOpen}
				style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
				className="action-speed-dial"
				ref={anchorEl}
			/>

			<UserAvatarMenu
				user={responsibleUser ?? null}
				users={usersList ?? []}
				size="xs"
				onClick={handleUserSelect}
			/>
		</>
	);
};
